import { AREA, DataSecurityLevel, DIAGNOSTIC_DETAILS, EVENT_CATEGORY, EVENT_NAME, PAGE_APP_NAME, PAGE_NAME, PAGE_TYPE, SUB_AREA, } from '@office-start/telemetry-types';
import { convertRouteToPage, filterPii, getFlattenedFieldName, getPageAppName, getPageType, } from '@office-start/telemetry-utility';
import { getCurrentRouteItem, isRouteInitialized, logEvent, } from '../TelemetryService';
/**
 * Logs diagnostic event with given properties. All Diagnostic event will be stored into a Kusto table `Office.Taos.Hub.Diagnostic`.
 *
 * Diagnostic events will only logged in short-term Kusto storage NOT long term data store such as COSMOS similar to generic_debug_cache_2 event in legacy aria instrumentation service.
 *      Reason:
 *      1. Diagnostic telemetry tends to be large and has a limited useful lifetime.
 *      2. Additionally, it may contain unexpected values that sometimes exceed the allowed System Metadata or EUPI classifications for our telemetry -- resulting in a potential privacy event.
 *
 *  @param properties Properties pertaining to diagnostic event
 *                    - eventName: KnownDiagnosticInstrumentationEvents;
 *                    - params: { [param: string]: string | number | boolean };
 *                      [NOTE] The key should be `PascalCased`.
 *  @param securityThreshold DataSecurityLevel corresponds to Windows PlatformDataCollectionLevel which are ignored outside UWP.
 *
 *
 * e.g.
 *     const diagnosticParams = {};
 *     diagnosticParams['Index'] = 5;
 *     diagnosticParams['RenderSize'] = '200';
 *
 *     logDiagnostic(
 *          {
 *              eventName: KnownDiagnosticInstrumentationEvents.Other,
 *              params: diagnosticParams,
 *         }
 *      );
 */
export function logDiagnostic(properties, securityThreshold) {
    if (securityThreshold === void 0) { securityThreshold = DataSecurityLevel.Security; }
    logEvent("Diagnostic" /* EventCategory.Diagnostic */, generateDiagnosticParams(properties), securityThreshold);
}
export function generateDiagnosticParams(properties) {
    var _a, _b;
    var params = {};
    for (var key in properties.params) {
        params[getFlattenedFieldName([DIAGNOSTIC_DETAILS, key])] =
            typeof properties[key] === 'string'
                ? filterPii(properties.params[key])
                : properties.params[key];
    }
    params[EVENT_CATEGORY] = "Diagnostic" /* EventCategory.Diagnostic */;
    params[EVENT_NAME] = properties.eventName;
    if (isRouteInitialized()) {
        var pageName = convertRouteToPage(getCurrentRouteItem());
        params[getFlattenedFieldName([DIAGNOSTIC_DETAILS, PAGE_NAME])] = pageName;
        params[getFlattenedFieldName([DIAGNOSTIC_DETAILS, PAGE_TYPE])] = getPageType(pageName);
        params[getFlattenedFieldName([DIAGNOSTIC_DETAILS, PAGE_APP_NAME])] = getPageAppName(pageName);
    }
    params[getFlattenedFieldName([DIAGNOSTIC_DETAILS, AREA])] =
        (_a = properties.area) !== null && _a !== void 0 ? _a : '';
    params[getFlattenedFieldName([DIAGNOSTIC_DETAILS, SUB_AREA])] =
        (_b = properties.subArea) !== null && _b !== void 0 ? _b : '';
    return params;
}
//# sourceMappingURL=logDiagnostic.js.map